import { MouseEvent, useContext } from 'react';
import { BackSection } from 'src/components/common/BackSection';
import { ModalContext } from 'src/contexts/ModalContext';

import * as styles from './AdGroupsToolbar.css';
import {
  AdGroupsToolbarDiv,
  FilterBarLeftSide,
  FilterBarRightSide,
} from './AdGroupsToolbar.styled';

export type AdGroupsToolbarType = {
  disabled?: boolean;
  onColumnSettingButtonClickHandler?: (
    e: MouseEvent<HTMLButtonElement>
  ) => void;
};

export function AdGroupsToolbar({
  returnUrl,
}: {
  returnUrl: string | undefined;
}) {
  const { setModal } = useContext(ModalContext);

  return (
    <AdGroupsToolbarDiv className={styles.adGroupsFilterBar}>
      <FilterBarLeftSide>
        {returnUrl && <BackSection returnUrl={returnUrl!} />}
      </FilterBarLeftSide>
      <FilterBarRightSide></FilterBarRightSide>
    </AdGroupsToolbarDiv>
  );
}
